import * as types from './types';
import createReducer from '../../utils/createReducer';

import initialState from './initialState';

const reducersMap = {
   [types.SITE_DETAILS_INIT_START]: (state) => {
      return {
         ...state,
         authUser: null,
         siteInfo: null,
         isSiteInited: false,
         menu: {
            ...state.menu,
            isMenuOpened: false,
            animationClass: 'default',
         },
      };
   },
   [types.SITE_DETAILS_INIT_COMPLETED]: (state, action) => {
      return {
         ...state,
         isSiteInited: true,
         isSiteDetailsRefreshing: false,
         ...action.payload,
      };
   },
   [types.SITE_DETAILS_INIT_FAILED]: (state) => {
      return {
         ...state,
         isSiteInited: true,
      };
   },
   [types.SITE_DETAILS_REFRESH_START]: (state) => {
      return {
         ...state,
         isSiteDetailsRefreshing: true,
      };
   },
   [types.RESET_COMMON_DETAILS]: () => {
      return {
         ...initialState,
      };
   },
   [types.SCREEN_RESIZE]: (state, action) => {
      return {
         ...state,
         screenWidth: action.payload.screenWidth,
      }
   },
   [types.COLLAPSE_MENU]: (state, action) => {
      return {
         ...state,
         menu: {
            ...state.menu,
            isMenuOpened: !state.menu.isMenuOpened,
            animationClass: !state.menu.isMenuOpened ? 'menu-hidden-animation' : 'menu-block-animation',
         },
      }
   },
   [types.UPDATE_AUTH_USER]: (state, action) => {
      const { payload } = action
      const data = {
         ...state.authUser,
         ...payload,
         compressed_avatar_src: payload.avatar_src,
      }
      return {
         ...state,
         authUser: data,
      }
   },

   [types.SET_VIEW_AS_MODAL]: (state, action) => {
      const { payload: {
         bool,
         url,
      } } = action
      let viewAsModal = {
         isOpen: bool,
      }
      if(url) {
         viewAsModal = {
            ...viewAsModal,
            url,
         }
      }
      return {
         ...state,
         viewAsModal,
      }
   },

   [types.SET_IS_ONLINE_STREAM]: (state, action) => {
      return {
         ...state,
         isOnlineStream: action.payload,
      };
   },

   [types.UPDATE_LIVE_STREAM_CURRENT_SESSION_STATE]: (state, action) => {
      return {
         ...state,
         liveStreamCurrentSessionState: {
            ...state.liveStreamCurrentSessionState,
            ...action.payload,
         },
      };
   },

   [types.OPEN_ONLINE_MEMBERS_MODAL]: (state, action) => {
      return {
         ...state,
         isOpenOnlineMembersModal: action.payload,
      }
   },
   [types.UPDATE_SITE_LONG_NAME_START]: (state, action) => {
      return {
         ...state,
         isUpdateSiteLongInfo: true,
         siteLongNameUpdateError: null,
      }
   },
   [types.UPDATE_SITE_LONG_NAME_COMPLETED]: (state, action) => {
      const { payload } = action
      return {
         ...state,
         isUpdateSiteLongInfo: false,
         siteInfo: {
            ...state.siteInfo,
            site_long_name: payload,
         },
      }
   },
   // [types.UPDATE_SITE_INFO_COMPLETED]: (state, action) => {
   //    const { payload } = action
   //    return {
   //       ...state,
   //       siteInfo: {
   //          ...state.siteInfo,
   //          ...payload,
   //       },
   //    }
   // },
   [types.UPDATE_SITE_NAME_FAILED]: (state, action) => {
      const { payload } = action

      return {
         ...state,
         isUpdateSiteLongInfo: false,
         siteLongNameUpdateError: payload,
      }
   },
   [types.UPDATE_CONTENT_META_INFO]: (state, action) => {
      const { payload } = action
      const defaultMetaInfo = state.siteInfo?.content_meta_info || {};
      return {
         ...state,
         siteInfo: {
            ...state.siteInfo,
            content_meta_info: {
               ...defaultMetaInfo,
               ...payload,
            },
         },
         // state.common.siteInfo?.content_meta_info: false,
         // siteLongNameUpdateError: payload,
      }
   },
   [types.SET_MASS_MESSAGE_LIMIT]: (state, action) => {
      const { payload } = action
      return {
         ...state,
         massMessageLimit: {
            ...state.massMessageLimit,
            ...payload,
         },
      }
   },
   [types.UPDATE_RECEIVED_ORDERS_COUNT]: (state, action) => {
      console.log(action.payload);
      return {
         ...state,
         received_orders_badge_count: action.payload,
      }
   },
   [types.UPDATE_IS_OFFLINE_MODE_START]: (state, action) => {
      const { payload } = action
      return {
         ...state,
         isUpdateOfflineMode: payload,
      }
   },
   [types.UPDATE_IS_OFFLINE_MODE_COMPLETED]: (state, action) => {
      const { payload } = action
      return {
         ...state,
         isUpdateOfflineMode: false,
         siteInfo: {
            ...state.siteInfo,
            ...payload,
         },
      }
   },
   [types.SET_IS_LOADING_CONNECT_TO_MYLIST]: (state, action) => {
      return {
         ...state,
         isLoadingConnectToMylist: action.payload,
      }
   },
   [types.CONNECT_TO_MYLIST_COMPLETED]: (state) => {
      return {
         ...state,
         accountType: 'all',
         isLoadingConnectToMylist: false,
      }
   },
   [types.UPDATE_SITE_INFO]: (state, action) => {
      const newState = action.payload || {}

      return {
         ...state,
         siteInfo: {
            ...state.siteInfo,
            ...newState,
         },
      }
   },
   [types.SET_SHARE_MODAL]: (state, action) => {
      const { payload } = action
      return {
         ...state,
         shareModal: payload,
      }
   },

   //all media reducers
   [types.FETCH_ALL_MEDIA_START]: (state, action) => {
      return {
         ...state,
         isAllMediaFetching: true,
         isAllMediaEmptyByFilter: false,
         isAllMediaFetchingByFilter: false,
         isAllMediaEmpty: false,
      }
   },
   [types.FETCH_ALL_MEDIA_COMPLETED]: (state, action) => {
      const  { payload: { data, emptyFilters } } = action;
      let newState = {
         isAllMediaEmpty: data.data.length === 0,
         isAllMediaEmptyByFilter: false,
      }
      if(!emptyFilters) {
         newState = {
            isAllMediaEmptyByFilter: data.data.length === 0,
         }
      }
      return {
         ...state,
         isAllMediaFetching: false,
         allMedia: data,
         ...newState,
         isInited: true,
      }
   },
   [types.FETCH_ALL_MEDIA_FAILED]: (state, action) => {
      return {
         ...state,
         isAllMediaFetching: false,
      }
   },

   [types.FETCH_NEW_ALL_MEDIA_START]: (state, action) => {
      return {
         ...state,
         isNewAllMediaFetching: !state?.isAllMediaEmptyByFilter,
      }
   },

   [types.FETCH_NEW_ALL_MEDIA_COMPLETED]: (state, action) => {
      const { payload: { data } } = action;
      return {
         ...state,
         isNewAllMediaFetching: false,
         isAllMediaFetchingByFilter: false,
         allMedia: {
            ...data,
            data: [...state.allMedia.data, ...data.data],
         },
      }
   },
   [types.FETCH_NEW_ALL_MEDIA_FAILED]: (state, action) => {
      return {
         ...state,
         isNewAllMediaFetching: false,
      }
   },

   [types.FETCH_ALL_MEDIA_BY_FILTER_START]: (state, action) => {
      return {
         ...state,
         isAllMediaFetchingByFilter: true,
         isNewAllMediaFetching: false,
      }
   },

   [types.FETCH_ALL_MEDIA_BY_FILTER_COMPLETED]: (state, action) => {
      const { data } = action.payload;
      return {
         ...state,
         isAllMediaFetchingByFilter: false,
         allMedia: data,
         isAllMediaEmptyByFilter: data.data.length === 0,
         isNewAllMediaFetching: false,
      }
   },
   [types.FETCH_ALL_MEDIA_BY_FILTER_FAILED]: (state, action) => {
      return {
         ...state,
         isAllMediaFetchingByFilter: false,
         isNewAllMediaFetching: false,
      }
   },
   [types.CLEAR_ALL_MEDIA_STATE]: (state, action) => {
      return {
         ...state,
         ...action.payload,
      }
   },
   [types.UPDATE_MESSAGE_ACTION]: (state, action) => {
      const { ids, data, messageId, isFilteredByUnsent, removedItemId } = action.payload;
      let allMediaData = state.allMedia.data || [];
      let updatedData = allMediaData

      updatedData = updatedData.reduce((prev, curr) => {
         let current = curr

         if(!!current?.messages?.length){

            current.messages = current.messages.map(message => {
               if(message?.id === messageId && message.unlock_details) {
                  current.messages = current.messages.filter(it => it.id !== messageId)
               }
               if(message?.id === messageId && message.unlock_details && message.unlock_details.resource_type === 'multiple_attachment') {
                  if(message.unlock_details.attachments && message.unlock_details.attachments.length > 1) {
                     return {
                        ...message,
                        unlock_details: {
                           ...message.unlock_details,
                           attachments: message.unlock_details.attachments.filter(ct => ct.resource_id !== ids[0]),
                        },
                     }

                  } else {
                     current.messages = current.messages.filter(it => it.id !== messageId)
                  }

               }
               return message
            })
         }

         prev.push(current)
         return prev
      }, [])


      allMediaData = updatedData.map((el) => {
         let { ...item } = el;
         if(ids.includes(item.id)){
            let messages = null;
            if(item.messages && !action?.payload?.isDeleteAll){
               if(data){
                  messages = [...item.messages].map((message) => {
                     let { ...m } = message;
                     if(m.id === messageId){
                        m = {
                           ...m,
                           ...data,
                        }
                     }
                     return m;
                  })
               } else {
                  messages = [...item.messages].filter(m => m.id !== messageId);
               }
            }
            item.messages = messages;
            if(!messages?.length){
               item.messages = null;
            }
         }
         return item
      }).filter(el => {
         if(!el.messages && !isFilteredByUnsent && el.id === removedItemId) {
            return null
         }

         return el
      })

      return {
         ...state,
         allMedia: {
            ...state?.allMedia,
            data: allMediaData,
         },
         isAllMediaEmptyByFilter: !isFilteredByUnsent && allMediaData?.length === 0 ? true : state?.isAllMediaEmptyByFilter,
      }
   },
};

export default createReducer(initialState)(reducersMap);
